import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const CMSMarketplaceSettingsComponent = ({ selectCMSSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Enable For Partner"
                            name="EnableForPartner"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForPartner',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForPartner}
                        />
                        <InputContainer
                            label="Enable For Franchisee"
                            name="EnableForFranchisee"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForFranchisee',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForFranchisee}
                        />
                        <InputContainer
                            label="Enable For Marketplace"
                            name="EnableForMarketplace"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForMarketplace',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForMarketplace}
                        />
                        <InputContainer
                            label="Enable For ONDC Store"
                            name="EnableForONDCStore"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForONDCStore',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForONDCStore}
                        />
                        <InputContainer
                            label="Enable For Vendor"
                            name="EnableForVendor"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForVendor',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForVendor}
                        />
                        <InputContainer
                            label="Enable For Department"
                            name="EnableForDepartment"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForDepartment',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForDepartment}
                        />
                        <InputContainer
                            label="Enable For DigitalClub"
                            name="EnableForDigitalClub"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForDigitalClub',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForDigitalClub}
                        />
                        <InputContainer
                            label="Enable For DeliverySchedule"
                            name="EnableForDeliverySchedule"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForDeliverySchedule',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForDeliverySchedule}
                        />
                        <InputContainer
                            label="Enable For CancelOrder"
                            name="EnableForCancelOrder"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForCancelOrder',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForCancelOrder}
                        />
                        <InputContainer
                            label="Enable For Online"
                            name="EnableForOnline"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForOnline',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForOnline}
                        />
                        <InputContainer
                            label="Enable For COD"
                            name="EnableForCOD"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForCOD',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForCOD}
                        />
                        <InputContainer
                            label="Enable For Parcel Online"
                            name="EnableForParcelOnline"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForParcelOnline',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForParcelOnline}
                        />
                        <InputContainer
                            label="Enable For Parcel COD"
                            name="EnableForParcelCOD"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForParcelCOD',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForParcelCOD}
                        />
                        <InputContainer
                            label="Enable For Wallet"
                            name="EnableForWallet"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForWallet',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForWallet}
                        />
                        <InputContainer
                            label="Enable For Subscription"
                            name="EnableForSubscription"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'MarketplaceSettings.EnableForSubscription',
                                    selectCMSSettings?.MarketplaceSettings
                                )
                            }}
                            type="checkbox"
                            value={selectCMSSettings?.MarketplaceSettings?.EnableForSubscription}
                        />
                    </div>
                }
                expandedPanel="Marketplace Settings"
                headerTitle="Marketplace Settings"
            />
        </>
    )
}
export default CMSMarketplaceSettingsComponent;
